import { InputTypes, PaymentFormField } from '@cashier/cashier-model';

import { ItemEnricher } from './model';

export const inputMasksMap: Partial<Record<InputTypes, string>> = {
  [InputTypes.ExpirationDate]: '99/99',
};

const hasMask = (field: PaymentFormField): boolean => {
  const inputType = field.name as InputTypes;

  return Boolean(inputMasksMap[inputType]);
};

export const FieldMaskEnricher: ItemEnricher = {
  shouldEnrich: (field) => hasMask(field),
  enrich: (field) => {
    const inputType = field.name as InputTypes;

    field.mask = inputMasksMap[inputType];
  },
};
